export const MOCK_STAGING_POLLINATOR: Readonly<{
	data: any;
	extensions: any;
}> = {
	data: {
		graphStore: {
			cypherQueryV2: {
				edges: [
					{
						node: {
							__typename: 'GraphStoreCypherQueryV2Node',
							columns: [
								{
									key: 'user',
									value: {
										id: 'ari:cloud:identity::user/5b5533009f58262d66383789',
										data: {
											__typename: 'AtlassianAccountUser',
											accountId: '5b5533009f58262d66383789',
											canonicalAccountId: 'ari:cloud:identity::user/5b5533009f58262d66383789',
											accountStatus: 'active',
											name: 'fusion-jswdd-bot@atlassian.com',
											picture:
												'https://avatar-management--avatars.us-west-2.staging.public.atl-paas.net/initials/F-2.png',
											characteristics: {
												not_mentionable: false,
											},
											email: null,
											zoneinfo: null,
											locale: 'en-US',
											nickname: 'fusion-jswdd-bot@atlassian.com',
											orgId: null,
											id: 'ari:cloud:identity::user/5b5533009f58262d66383789',
										},
									},
								},
								{
									key: 'issues',
									value: {
										id: 'ari:cloud:jira:0762a86e-e572-469e-9161-c02953504143:issue/74399',
										data: {
											__typename: 'JiraIssue',
											id: 'ari:cloud:jira:0762a86e-e572-469e-9161-c02953504143:issue/74399',
											issueId: '74399',
											key: 'AGSM-3',
											webUrl: 'https://fusion-pollinator.jira-dev.com/browse/AGSM-3',
											issueTypeAvatarUrl:
												'https://fusion-pollinator.jira-dev.com/rest/api/2/universal_avatar/view/type/issuetype/avatar/10318?size=medium',
											summary: 'AGS Cypher Query Semantic Test - issue has assignee (Staging)',
											isArchived: false,
											archivedOn: null,
											isResolved: false,
											canCreateSubtask: true,
											canBeExported: true,
											canDownloadAttachment: false,
											shouldShowPlaybooks: false,
											totalAttachmentsCount: 0,
											deletableAttachmentsCount: 0,
											exceededChildIssueLimit: false,
											hasChildIssues: false,
											configurationUrl:
												'https://fusion-pollinator.jira-dev.com/https:/confluence.atlassian.com/jirasoftwarecloud/configure-field-layout-in-the-issue-view-961798059.html',
											lastViewedTimestamp: null,
											hasCustomisedContentPanels: false,
											mercuryProjectName:
												'AGS Cypher Query Semantic Test - issue has assignee (Staging)',
											mercuryProjectUrl: 'https://fusion-pollinator.jira-dev.com/browse/AGSM-3',
											mercuryProjectKey: 'AGSM-3',
											mercuryProjectIcon:
												'https://fusion-pollinator.jira-dev.com/rest/api/2/universal_avatar/view/type/issuetype/avatar/10318?size=medium',
											mercuryProjectProviderName: 'JIRA',
											mercuryTargetDateStart: null,
											mercuryTargetDateEnd: null,
											mercuryTargetDateType: 'DAY',
											lastRedactionTime: null,
											dueDateField: {
												id: 'ari:cloud:jira:0762a86e-e572-469e-9161-c02953504143:issuefieldvalue/74399/duedate',
											},
											startDateField: {
												id: 'ari:cloud:jira:0762a86e-e572-469e-9161-c02953504143:issuefieldvalue/74399/customfield_10015',
											},
											projectField: {
												id: 'ari:cloud:jira:0762a86e-e572-469e-9161-c02953504143:issuefieldvalue/74399/project',
											},
											parentIssueField: {
												id: 'ari:cloud:jira:0762a86e-e572-469e-9161-c02953504143:issuefieldvalue/74399/parent',
											},
											assigneeField: {
												id: 'ari:cloud:jira:0762a86e-e572-469e-9161-c02953504143:issuefieldvalue/74399/assignee',
											},
											summaryField: {
												id: 'ari:cloud:jira:0762a86e-e572-469e-9161-c02953504143:issuefieldvalue/74399/summary',
											},
											issueRestrictionField: {
												id: 'ari:cloud:jira:0762a86e-e572-469e-9161-c02953504143:issuefieldvalue/74399/issuerestriction',
											},
											issueType: {
												id: 'ari:cloud:jira:0762a86e-e572-469e-9161-c02953504143:issue-type/10261',
											},
											issueTypeField: {
												id: 'ari:cloud:jira:0762a86e-e572-469e-9161-c02953504143:issuefieldvalue/74399/issuetype',
											},
											status: {
												id: 'ari:cloud:jira:0762a86e-e572-469e-9161-c02953504143:issue-status/activation/58a44bf7-5a68-4c56-ab19-4391fa88f62e/10245',
											},
											statusField: {
												id: 'ari:cloud:jira:0762a86e-e572-469e-9161-c02953504143:issuefieldvalue/74399/status',
											},
											statusCategory: {
												id: 'SmlyYVN0YXR1c0NhdGVnb3J5OjI',
											},
											priorityField: {
												id: 'ari:cloud:jira:0762a86e-e572-469e-9161-c02953504143:issuefieldvalue/74399/priority',
											},
											descriptionField: {
												id: 'ari:cloud:jira:0762a86e-e572-469e-9161-c02953504143:issuefieldvalue/74399/description',
											},
											createdField: {
												id: 'ari:cloud:jira:0762a86e-e572-469e-9161-c02953504143:issuefieldvalue/74399/created',
											},
											updatedField: {
												id: 'ari:cloud:jira:0762a86e-e572-469e-9161-c02953504143:issuefieldvalue/74399/updated',
											},
											resolutionField: {
												id: 'ari:cloud:jira:0762a86e-e572-469e-9161-c02953504143:issuefieldvalue/74399/resolution',
											},
											resolutionDateField: {
												id: 'ari:cloud:jira:0762a86e-e572-469e-9161-c02953504143:issuefieldvalue/74399/resolutiondate',
											},
											securityLevelField: {
												id: 'ari:cloud:jira:0762a86e-e572-469e-9161-c02953504143:issuefieldvalue/74399/security',
											},
											timeTrackingField: {
												id: 'ari:cloud:jira:0762a86e-e572-469e-9161-c02953504143:issuefieldvalue/74399/timetracking',
											},
											timeOriginalEstimateField: null,
											votesField: {
												id: 'ari:cloud:jira:0762a86e-e572-469e-9161-c02953504143:issuefieldvalue/74399/votes',
											},
											watchesField: {
												id: 'ari:cloud:jira:0762a86e-e572-469e-9161-c02953504143:issuefieldvalue/74399/watches',
											},
											atlassianProjectField: null,
											issueColorField: null,
											storyPointsField: null,
											storyPointEstimateField: null,
											issueLinkField: {
												id: 'ari:cloud:jira:0762a86e-e572-469e-9161-c02953504143:issuefieldvalue/74399/issuelinks',
											},
											confluenceRemoteIssueLinksField: {
												id: 'ari:cloud:jira:0762a86e-e572-469e-9161-c02953504143:issuefieldvalue/74399/confluenceRemoteIssueLinks',
											},
											childIssues: null,
											jiraCoverMedia: null,
											mercuryProjectStatus: {
												__typename: 'JiraStatusCategory',
											},
											mercuryOriginalProjectStatus: {
												__typename: 'JiraStatus',
											},
											mercuryProjectType: {
												__typename: 'JiraIssueType',
											},
											mercuryProjectOwner: {
												__typename: 'AtlassianAccountUser',
												accountId: '5b5533009f58262d66383789',
												canonicalAccountId: 'ari:cloud:identity::user/5b5533009f58262d66383789',
												accountStatus: 'active',
												name: 'fusion-jswdd-bot@atlassian.com',
												picture:
													'https://avatar-management--avatars.us-west-2.staging.public.atl-paas.net/initials/F-2.png',
												characteristics: {
													not_mentionable: false,
												},
												email: null,
												zoneinfo: null,
												locale: 'en-US',
												nickname: 'fusion-jswdd-bot@atlassian.com',
												orgId: null,
												id: 'ari:cloud:identity::user/5b5533009f58262d66383789',
											},
											reporter: {
												__typename: 'AtlassianAccountUser',
												accountId: '5cc8ebd1c2e4550e3df45601',
												canonicalAccountId: 'ari:cloud:identity::user/5cc8ebd1c2e4550e3df45601',
												accountStatus: 'active',
												name: 'Neha Mundada',
												picture:
													'https://avatar-management--avatars.us-west-2.staging.public.atl-paas.net/initials/NM-0.png',
												characteristics: {
													not_mentionable: false,
												},
												email: null,
												zoneinfo: null,
												locale: 'en-US',
												nickname: 'Neha Mundada',
												orgId: null,
												id: 'ari:cloud:identity::user/5cc8ebd1c2e4550e3df45601',
											},
											archivedBy: null,
											summarisedBuilds: null,
											summarisedDeployments: null,
										},
									},
								},
							],
						},
					},
				],
			},
		},
	},
	extensions: {
		gateway: {
			request_id: 'staging-pollinator-mock-request-id',
			tId: 'staging-pollinator-mock-trace-id',
			crossRegion: false,
			edgeCrossRegion: false,
		},
	},
};
